import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaMicrophone, FaLinkedin } from "react-icons/fa";
import DiscussionPanelists from "../HomeComonents/DiscussionPanelists-homepage-section";
import SummerThemeWrapper from "../Home/SummerThemeWrapper";

const SummerMembersMeet2026Details = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  const title = "MSB Association Summer Members Meet 2026, proudly sponsored by Peratera";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <SummerThemeWrapper>
      <div>
        <Helmet>
          <title>Summer Members Meet 2026 | Money Service Business Association UK</title>
          <meta name="description" content="Highlights and insights from the MSB Association Summer Members Meet 2026 proudly sponsored by Peratera." />
          <meta property="og:title" content="Summer Members Meet 2026 | MSB Association UK" />
          <meta property="og:description" content="Join us in reviewing the highlights from our 2026 Summer Members Meet in London." />
          <meta property="og:type" content="website" />
        </Helmet>

        <main className="page_content">
          <style>{`
        .speaker-card-hover {
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .speaker-card-hover:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.12) !important;
        }
        .speaker-card-hover hr {
          transition: width 0.4s ease;
        }
        .speaker-card-hover:hover hr {
          width: 95% !important;
        }

        .speaker-name-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: inherit;
          text-decoration: none;
          transition: color 0.3s ease;
        }
        .linkedin-static-icon {
          color: #0a66c2;
          font-size: 26px;
          display: flex;
          transition: all 0.3s ease;
        }
        .linkedin-static-icon:hover {
          transform: scale(1.2);
          color: #004182;
        }
        
        .btn_learn_more {
          background: #f7931e;
          color: #fff !important;
          padding: 12px 25px;
          border-radius: 50px;
          font-weight: 700;
          transition: all 0.3s ease;
          display: inline-block;
          margin-top: 20px;
          text-decoration: none;
          box-shadow: 0 4px 15px rgba(247, 147, 30, 0.2);
          width: 100%;
        }
        .btn_learn_more:hover {
          background: #e6821d;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(247, 147, 30, 0.3);
        }
      `}</style>
          {/* Page Header */}
          <section
            id="overview"
            className="page_header text-center section_decoration overflow-hidden"
            style={{ background: "#333" }}
          >
            <div className="container">
              <motion.h1
                className="page_title text-white"
                initial="hidden"
                animate="visible"
                style={{
                  display: "block",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: "1100px",
                  margin: "0 auto"
                }}
              >
                {title.split(" ").map((word, wordIndex) => (
                  <span key={`word-${wordIndex}`} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                    {word.split("").map((letter, charIndex) => {
                      const globalIndex = title.split(" ").slice(0, wordIndex).join(" ").length + (wordIndex > 0 ? 1 : 0) + charIndex;
                      return (
                        <motion.span
                          key={`char-${wordIndex}-${charIndex}`}
                          custom={globalIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                    {/* Add space after word if not the last word */}
                    {wordIndex < title.split(" ").length - 1 && (
                      <span style={{ display: "inline-block", width: "0.3em" }}>&nbsp;</span>
                    )}
                  </span>
                ))}
              </motion.h1>
              <ul className="breadcrumb_nav unordered_list justify-content-center">
                <li>
                  <NavLink to="/events">Events</NavLink>
                </li>
                <li className="active">
                  <a href="#!">Summer Members Meet 2026</a>
                </li>
              </ul>
            </div>
          </section>

          {/* Content Section */}
          <section className="contact_section section_space bg-white">
            <div className="container">
              <div className="item_details_content p-3">
                <div className="d-flex justify-content-end mb-3">
                  <NavLink to="/events" className="btn bg-primary text-dark">
                    &larr; Back
                  </NavLink>
                </div>

                <img
                  className="img-fluid rounded-2"
                  src="assets/images/gallery/year-2026/summer-meet-2026/11.webp"
                  alt="MSB summer Members Meet 2026"
                  onError={(e) => { e.target.src = "https://placehold.co/1200x600?text=MSB+summer+Meet+2026+Main+Banner"; }}
                />

                <h3 className="mt-4 mb-3 text-center text-dark">
                  MSB Association Summer Members Meet 2026, proudly sponsored by Peratera
                </h3>

                <h4 className="text-dark text-center mb-5" style={{ color: "#f7931e !important" }}>
                  What an evening! A perfect blend of networking, industry insights & meaningful connections.
                </h4>
                <p className="mb-2 text-dark">
                  On <strong>Friday, 26th June 2026</strong>, the MSB community came together once again in the heart of London for an unforgettable summer evening of collaboration, knowledge sharing, and relationship building.
                </p>
                <p className="mb-2 text-dark">
                  Hosted at the stunning <strong>1864 Rooftop Bar & Kitchen</strong>, the event welcomed <strong>60+ MSB business owners, compliance professionals, fintech leaders, payment providers, and industry decision-makers</strong> from across the Money Service Business sector.
                </p>
                <p className="mb-2 text-dark">
                  From insightful keynote sessions and expert discussions to valuable networking opportunities overlooking London's iconic skyline, the evening created new connections, inspired fresh ideas, and strengthened the UK MSB community.
                </p>
                <p className="text-dark">
                  This was more than just a networking event—it was an opportunity to connect, collaborate, and drive the future of the MSB industry together.
                </p>

                {/* Keynote Address Section */}
                <div className="mt-5">
                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                    <div className="schedule-date fw-bold fs-5 mx-3" style={{ whiteSpace: 'nowrap' }}>
                      Keynote Address: Expert Insights
                    </div>
                    <div style={{ flex: 1, height: '2px', background: '#f7931e', borderRadius: '2px' }}></div>
                  </div>
                  <div className="text-center">
                    <p className="text-dark mb-5">
                      Our keynote speakers delivered insightful and thought-provoking sessions, bringing both regulatory depth and innovation to the forefront.
                    </p>
                  </div>

                  <div className="row justify-content-center g-5">
                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          <img
                            src="assets/images/meetup-2026/Dimitri-Savchenko.png"
                            alt="Mr. Dmitri Savtchenko"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: 'white' }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Dmitri+Savtchenko"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Mr. Dmitri Savtchenko
                            {/* <a
                              href="https://www.linkedin.com/in/saima-hanif-kc-4947662/"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a> */}
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “Helping Remittance Businesses Scale with Confidence”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>The Challenges Facing Remittance Businesses Today</li>
                            <li>How Peratera Supports Remittance Businesses</li>
                            <li>Why Remittance Firms Choose Peratera</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          <img
                            src="assets/images/meetup-2026/vishal-sir-26.png"
                            alt="Mr. Vishal Patil"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', objectPosition: 'top', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: 'white' }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Vishal+Patil"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Mr. Vishal Patil
                            {/* <a
                              href="https://uk.linkedin.com/in/vishal-patil-78181914"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a> */}
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “The Reality of Our Industry”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>Current challenges shaping the remittance sector</li>
                            <li>Regulatory and market trends affecting MSBs</li>
                            <li>Opportunities for growth and collaboration</li>
                            <li>Preparing the industry for the future</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          <img
                            src="assets/images/meetup-2026/Mizan-Abdulrouf.png"
                            alt="Mr. Mizan Abdulrouf"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', objectPosition: 'top', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: 'white' }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Vishal+Patil"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Mr. Mizan Abdulrouf
                            {/* <a
                              href="https://uk.linkedin.com/in/vishal-patil-78181914"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a> */}
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “Governance, Compliance & the Evolving Regulatory Landscape”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>Strengthening governance in regulated businesses</li>
                            <li>Compliance as a driver of sustainable growth</li>
                            <li>Key regulatory challenges facing the industry</li>
                            <li>Practical insights from international regulatory experience</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-5">
                      <div
                        className="blog_post_block h-100 speaker-card-hover"
                        style={{
                          padding: "50px 30px",
                          border: "1px solid #ffd700",
                          borderRadius: "24px",
                          background: "#fff",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
                        }}
                      >
                        <div className="showaround-container mb-5" style={{ position: 'relative', width: '280px', margin: '0 auto' }}>
                          <div style={{ position: 'absolute', top: '-18px', left: '-18px', width: '90px', height: '90px', background: '#f7931e', zIndex: 0 }}></div>
                          <div style={{ position: 'absolute', bottom: '-18px', right: '-18px', width: '130px', height: '130px', borderRight: '3px solid #000', borderBottom: '3px solid #000', zIndex: 0 }}></div>
                          <img
                            src="assets/images/meetup-2026/Naveed-Akhter.png"
                            alt="Mr. Naveed Akhter"
                            style={{ width: '280px', height: '300px', objectFit: 'cover', objectPosition: 'top', position: 'relative', zIndex: 1, filter: 'grayscale(100%) brightness(1.1)', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: 'white' }}
                            onError={(e) => { e.target.src = "https://placehold.co/400x400?text=Naveed+Akhter"; }}
                          />
                        </div>

                        <div className="post_content text-center">
                          <h4 className="text-dark fw-bold mb-2 d-flex align-items-center justify-content-center gap-2">
                            Mr. Naveed Akhter
                            {/* <a
                              href="https://uk.linkedin.com/in/vishal-patil-78181914"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="linkedin-static-icon"
                              title="View LinkedIn Profile"
                            >
                              <FaLinkedin />
                            </a> */}
                          </h4>
                          <p className="small mb-3" style={{ color: "#888" }}>Keynote Speaker</p>
                          <hr style={{ borderTop: "1px solid #eee", width: "80%", margin: "0 auto 15px" }} />
                          <div className="d-flex align-items-center mb-4 text-start">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                background: "#f7931e",
                                minWidth: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                marginRight: "15px",
                                boxShadow: "0 4px 10px rgba(247, 147, 30, 0.2)",
                                flexShrink: 0
                              }}
                            >
                              <FaMicrophone size={22} color="#fff" />
                            </div>
                            <h6 className="text-dark fw-bold mb-0" style={{ lineHeight: "1.4" }}>
                              “Scaling an MSB Under FCA Expectations”
                            </h6>
                          </div>
                          <ul className="text-start text-dark small" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            <li>The current realities and challenges facing MSBs</li>
                            <li>What changes as your business scales</li>
                            <li>FCA expectations for governance, controls, and compliance</li>
                            <li>A practical roadmap for sustainable growth and regulatory readiness</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <p className="mt-5 text-dark">
                    <strong>
                      Together, these sessions provided a well-rounded perspective, helping MSBs better understand regulatory expectations while exploring emerging innovations.
                    </strong>
                  </p> */}
                </div>





                {/* Event Highlights Section */}
                <div className="row mb-5 mt-5">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      Event Highlights
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul className="text-dark">
                          <li>60+ attendees from MSBs, fintech, payments, legal, and compliance sectors</li>
                          <li>Inspiring keynote sessions from distinguished industry experts</li>
                          <li>Practical insights on FCA expectations, compliance, governance, and business growth</li>
                          <li>High-value networking with MSB owners, fintech leaders, and payment providers</li>
                          <li>Delicious food, refreshing drinks, and a stunning rooftop atmosphere</li>
                          <li>Meaningful conversations fostering new partnerships and industry collaboration</li>
                          <li>A collaborative environment driving innovation and growth across the UK MSB sector</li>
                        </ul>
                      </div>
                      <p className="text-dark">
                        <strong>
                          <em>
                            “This wasn’t just a meetup—it was a platform for real conversations, practical insights, and industry collaboration.”
                          </em>
                        </strong>
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div
                      className="p-0 overflow-hidden"
                      style={{
                        background: "#000",
                        borderRadius: "15px",
                        border: "2px solid #f7931e",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                        aspectRatio: "16 / 9",
                        width: "100%",
                        marginTop: "40px"
                      }}
                    >
                      {/* <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/TSv9xk0M6Ag?rel=0&autoplay=1&mute=1&loop=1&playlist=TSv9xk0M6Ag&controls=0&modestbranding=1"
                        title="MSB Association summer Members Meet 2026 Highlights"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe> */}
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/j4P4zjBaKzs?rel=0&autoplay=1&mute=1&loop=1&playlist=j4P4zjBaKzs&controls=0&modestbranding=1"
                        title="MSB Association Summer Members Meet 2026 Highlights"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                {/* Footer CTA Section */}
                <div
                  className="p-5 mt-5 text-center"
                  style={{ background: "#f7931e", borderRadius: "10px" }}
                >
                  <div className="row align-items-center">
                    <div className="col-lg-12">
                      <h2 className="heading_text mb-4 text-white">
                        What’s Next?
                      </h2>
                      <p className="mb-3 text-white">
                        <strong>
                          This marks another successful year of bringing the MSB community together. We are excited to continue growing this platform for collaboration, innovation, and knowledge sharing.
                        </strong>
                      </p>
                      <h5 className="text-white">
                        Stay Tuned - Engage with the MSB Network
                      </h5>
                      <NavLink
                        className="btn-black bg-primary btn-rounded mt-4"
                        to="/overview#membership-form"
                      >
                        <span className="btn_label">Become a Member</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
    </SummerThemeWrapper>
  );
};

export default SummerMembersMeet2026Details;

